import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SecretariaRoutingModule } from './secretaria-routing.module';
import { SecretariaChatComponent } from './secretaria-chat/secretaria-chat.component';
import { ComponentesModule } from '../../core/componentes/componentes.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, FormsModule, ComponentesModule, SecretariaChatComponent, SecretariaRoutingModule]
})
export class SecretariaModule {}
